import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { VPie } from 'vuetify/labs/VPie';
import { en, fr } from 'vuetify/locale';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import { Colors } from '../public/styles/utils/variables';

const vuetify = createVuetify({
    components: {
        ...components,
        VPie,
    },
    directives,

    locale: {
        locale: 'en',
        fallback: 'en',
        messages: {
            en,
            fr,
        },
    },

    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#013067',
                    secondary: '#00A9CE',
                    accent: '#82B1FF',
                    error: '#E84130',
                    info: '#8F969E',
                    success: '#2A750F',
                    warning: '#D1A918',
                    chip: '#D5D5D5',
                    ...Colors,
                },
            },
            // Le Futur Theme dark ici
        },
    },
    defaults: {
        AQTextField: {
            class: 'aquassist-text-field',
        },
    },
});

export default vuetify;
